import { useParams } from "react-router-dom";
import Spinner from "../components/Spinner";
import OrderDetails from "../components/OrderDetails";
import { useEffect } from "react";
import { useOrder } from "../hooks/useOrder";

interface Props {
  customerId?: string;
}

export const OrderDetail = ({ customerId }: Props) => {
  const { id: orderId } = useParams();
  const { order, loading, error, fetchOrder } = useOrder();

  useEffect(() => {
    if (orderId && orderId !== order?.id) {
      (async () => fetchOrder(orderId, customerId))();
    }
  }, []);

  if (loading) {
    return <Spinner />;
  }

  if (!order) {
    return <div>Order not found</div>;
  }

  return <OrderDetails {...order} />;
};

export default OrderDetail;
